import type { Props } from "./types";

const DetailsBox = ({
  items,
  correct,
  inCorrect,
  noAnswers,
  total,
  className,
  withHeader = false,
  header
}: Props) => {
  return (
    <div
      className={`bg-white p-3 rounded-b-2 border border-[#E2E8F0] ${className || ""} ${withHeader ? "rounded-t-2" : ""}`}
    >
      {withHeader && (
        <div className="flex items-center justify-between border-b border-[#EAECF0] pb-2 mb-3">
          <p className="text-xs font-semibold text-neutral-700">
            {header?.title ?? ""}
          </p>

          <span className="text-xs font-semibold text-neutral-700">
            {header?.value ?? ""}
          </span>
        </div>
      )}
      <dl className="grid grid-cols-1 gap-y-2">
        {items.map((item, idx) => (
          <div
            key={`${item.title}-${idx}`}
            className="flex items-center justify-between w-full h-7"
          >
            <dt className="text-xs font-medium text-neutral-600">
              {item.title}
            </dt>

            <dd dir="ltr" className="text-xs font-semibold text-neutral-600">
              {item.value}
            </dd>
          </div>
        ))}
      </dl>

      <div className="flex mt-2 h-6 px-5 items-center justify-between bg-[rgba(0,_0,_0,_0.03)] rounded-2 gap-8">
        <div className="flex items-center gap-1 text-xs font-medium text-[#12B76A] relative after:absolute after:-left-1/2 after:top-[2px] after:w-[1px] after:h-3 after:bg-[#D0D5DD] after:content-normal">
          <dt>درست:</dt>

          <dd>{correct}</dd>
        </div>

        <div className="flex items-center gap-1 text-xs font-medium text-[#F04438] relative after:absolute after:-left-1/2 after:top-[2px] after:w-[1px] after:h-3 after:bg-[#D0D5DD] after:content-normal">
          <dt>غلط:</dt>

          <dd>{inCorrect}</dd>
        </div>

        <div className="flex items-center gap-1 text-xs font-medium text-[#667085] relative after:absolute after:-left-1/2 after:top-[2px] after:w-[1px] after:h-3 after:bg-[#D0D5DD] after:content-normal">
          <dt>نزده:</dt>

          <dd>{noAnswers}</dd>
        </div>

        {total ? (
          <div className="flex items-center gap-1 text-xs font-medium text-neutral-700 ">
            <dt>کل:</dt>

            <dd>{total}</dd>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DetailsBox;
